export const steps = [
  {
    label: 'Información',
  },
  {
    label: 'Datos de contacto',
  },
  {
    label: 'Método de Pago',
  },
  {
    label: 'Confirmación',
  },
];

export const attemptClipPayment = (data) =>
  fetch('https://app.intelimotor.com/api/shops/payments/clip', {
    method: 'POST',
    body: JSON.stringify(data),
    headers: {
      'Content-type': 'application/json; charset=UTF-8',
    },
  }).then((res) => res.json());

export const updateClipPayment = (data) =>
  fetch('https://app.intelimotor.com/api/shops/payments/clip', {
    method: 'PUT',
    body: JSON.stringify(data),
    headers: {
      'Content-type': 'application/json; charset=UTF-8',
    },
  }).then((res) => res.json());

export const fetchClipPayment = async (API_KEY, paymentId) =>
  new Promise((resolve, reject) => {
    fetch(`https://api.payclip.com/payments/${paymentId}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${API_KEY}`,
      },
    })
      .then((response) => response.json())
      .then(resolve)
      .catch(reject);
  });

export default { attemptClipPayment };
